import { Box, Typography } from "@mui/material";

export default function NotFound() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        gap: 1,
        color: "#94a3b8",
      }}
    >
      <Typography variant="h2" sx={{ color: "#475569", fontWeight: 700 }}>
        403
      </Typography>
      <Typography variant="h5">Access Denied</Typography>
      <Typography variant="body2">You do not have permission to view this page.</Typography>
    </Box>
  );
}